// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { databaseCheck16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-database-check': IconDatabaseCheck;
    }
}

/**
 * The icon component for the 'databaseCheck' icon
 */
export class IconDatabaseCheck extends IconSvg {
    public constructor() {
        super(databaseCheck16X16);
    }
}

registerIconSvg('icon-database-check', IconDatabaseCheck);
export const iconDatabaseCheckTag = 'nimble-icon-database-check';
